var HintManager = {} ;

HintManager.error = function(errorText='')
{
    if(errorText!=='')
        alert(errorText);
}

HintManager.noInternetConnectionError = function()
{
    HintManager.error('ارتباط به اینترنت قطع شده است.');
}

export default HintManager ;


// WEBPACK FOOTER //
// ./src/Core/HintManager.js